varying vec2 vUv;
uniform float u_aspect;  // Pass aspect ratio from JS

float round_rect(vec2 p, vec2 size, vec4 radii) { // fold
    radii.xy = (p.x>0.0)?radii.xy : radii.zw;
    radii.x  = (p.y>0.0)?radii.x  : radii.y;
    vec2 q = abs(p)-size+radii.x;
    return min(max(q.x,q.y),0.0) + length(max(q,0.0)) - radii.x;
}
   
vec3 color_for_pixel(vec2 pixel, float time) {
    
    vec3 skin_color = vec3(0.838, 0.799, 0.760);
    
    // head
    float dist = round_rect(
        pixel, 
        vec2(.36, 0.6385), 
        vec4(.34, .415, .363, .315)
    );
    if (dist < 0.) return skin_color;
    
    // ear
    dist = round_rect(
        pixel + vec2(-.32, .15), 
        vec2(.15, 0.12), 
        vec4(.13,.1,.13,.13));
    if (dist < 0.) return skin_color;
    
    return vec3(1);
}

void main() {
    // Convert UV from [0,1] to [-1,1], so (0,0) is the center
    vec2 pixel = vUv * 2.0 - 1.0;

    // ✅ Fix: Correct the aspect ratio
    pixel.x *= u_aspect;

    vec3 color = color_for_pixel(pixel, 0.0);
    gl_FragColor = vec4(color, 1.0);
}
